import {
  CORE_LOAD_ALL_VERSION_REQUEST,
  CORE_LOAD_ALL_VERSION_SUCCESS,
  CORE_LOAD_ALL_VERSION_FAILURE,

  CORE_LOAD_VERSION_REQUEST,
  CORE_LOAD_VERSION_SUCCESS,
  CORE_LOAD_VERSION_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allVersion: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_VERSION_REQUEST:
        return requestState
      case CORE_LOAD_ALL_VERSION_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_VERSION_FAILURE:
        return initialState
      default:
        return state
    }
  },
  versionInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_VERSION_REQUEST:
        return requestState
      case CORE_LOAD_VERSION_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_VERSION_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerVersion.js